import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GenerateClientSummaryMutation,
  GenerateClientSummaryMutationVariables,
  GenerateAdaptiveClientSummaryMutation,
  GenerateAdaptiveClientSummaryMutationVariables,
} from "./ClientSummary.generated";

export const GENERATE_CLIENT_SUMMARY: TypedDocumentNode<
  GenerateClientSummaryMutation,
  GenerateClientSummaryMutationVariables
> = gql`
  mutation generateClientSummary(
    $noteUuid: String!
    $streamingTaskUuid: String
  ) {
    generateClientSummary(
      noteUuid: $noteUuid
      streamingTaskUuid: $streamingTaskUuid
    ) {
      ok
    }
  }
`;

export const GENERATE_ADAPTIVE_CLIENT_SUMMARY: TypedDocumentNode<
  GenerateAdaptiveClientSummaryMutation,
  GenerateAdaptiveClientSummaryMutationVariables
> = gql`
  mutation generateAdaptiveClientSummary(
    $noteUuid: String!
    $templateUuid: String!
  ) {
    generateAdaptiveClientSummary(
      noteUuid: $noteUuid
      templateUuid: $templateUuid
    ) {
      ok
    }
  }
`;
